import apiServices from '@/shared/services/api/axios'

const CountAccessService = {
    apiGetListCountAccess(payload: any) {
        let url = 'tax-advisor/count-access-advisor'

        if (payload) {
            let index = 0
            for (const key in payload) {
                if (payload[key]) {
                    if (!index) {
                        url += `?${key}=${payload[key]}`
                    }
                    if (index) {
                        url += `&${key}=${payload[key]}`
                    }
                    index++
                }
            }
        }
        return apiServices.get(url)
    }
}
export default CountAccessService
